const greedyAlgorithmsProblems = [
  {
      title: "Best Time to Buy and Sell Stocks",
      url: "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/"
    },
    {
      title: "Jump Game",
      url: "https://leetcode.com/problems/jump-game/"
    },
    {
      title: "Gas Station",
      url: "https://leetcode.com/problems/gas-station/"
    },
    {
      title: "Non-overlapping Intervals",
      url: "https://leetcode.com/problems/non-overlapping-intervals/"
    },
    {
      title: "Partition Labels",
      url: "https://leetcode.com/problems/partition-labels/"
    }
];
export default greedyAlgorithmsProblems;